export default [
  {
    'id': '5799c9b4732db5d32485c166',
    'cover': 'https://storage.googleapis.com/worldspaceschool/courses/covers/SpacecraftDesignEngineering970x424-min.jpg',
    'thumbs': 'https://storage.googleapis.com/worldspaceschool/courses/thumbs/SpacecraftDesignEngineering535x282-min.jpg',
    'title': 'SPACECRAFT DESIGN ENGINERING',
    'excerpt': 'This course is an overview of spacecraft design engineering. Topics included in this course are "Fundamentals of orbital mechanics", "Thermal design of satellite" and "Fundamentals of spacecraft attitude dynamics and control".',
    'description': 'This course is an overview of spacecraft design engineering. Topics included in this course are "Fundamentals of orbital mechanics", "Thermal design of satellite" and "Fundamentals of spacecraft attitude dynamics and control".'
  },
  {
    'id': '5799c9b47c2bb37849d2dc8f',
    'cover': 'https://storage.googleapis.com/worldspaceschool/courses/covers/MessageFromSpace970x424-min.jpg',
    'thumbs': 'https://storage.googleapis.com/worldspaceschool/courses/thumbs/MessageFromSpace535x282-min.jpg',
    'title': 'MESSAGE FROM SPACE',
    'excerpt': 'This course is a message from astronaut Naoko Yamazaki. Topics included in this course are "indtroduction to International Space Station (ISS) and activities on ISS" and "space exploration and international cooperation".',
    'description': 'This course is a message from astronaut Naoko Yamazaki. Topics included in this course are "indtroduction to International Space Station (ISS) and activities on ISS" and "space exploration and international cooperation".'
  },
  {
    'id': '5799c9b47c2bb37849d2d3cd',
    'cover': 'https://storage.googleapis.com/worldspaceschool/courses/covers/RemoteSensingCover.png',
    'thumbs': 'https://storage.googleapis.com/worldspaceschool/courses/thumbs/RemoteSensingThumb535.png',
    'title': 'REMOTE SENSING/GIS',
    'excerpt': 'This course is an overview of space technology for earth observation. Topics included in this course are "Principal of remote sensing", "Characteristics of electro-magnetic radiation", "Classification of electro-magnetic adiation in wave length", "Image Resolution and Image Interpretation".'
  }
];



/** WEBPACK FOOTER **
 ** ./src/data/courses.js
 **/